<div class="login-form-container w-100 h-100 main-panel">
  <div
    class="w-100 mx-auto d-flex align-items-center justify-content-center flex-column gap-3"
  >
    <div style="max-width: 300px" class="mx-auto d-block w-100">
      <div class="login-details-logo-container w-100">
        <img
          src="/assets/images/logo.png"
          style="max-width: 60px"
          class="w-100 d-block mx-auto"
        />
        <p class="text monek-font">MONEK</p>
      </div>
      @if (step === 'login' || mfaConfig === undefined) {
        <form class="w-100 mx-auto">
          <!-- bootstrap style email and password -->
          @if (newLogin) {
            <div class="form-item mb-3 mx-0 w-100">
              <label for="email" class="form-label">Email</label>
              <input
                type="email"
                id="email"
                data-test="login-email"
                class="form-control form-control-lg"
                placeholder="Enter your email"
                [(ngModel)]="email"
                name="email"
                required
              />
            </div>
            <div class="form-item mb-3 mx-0 w-100">
              <label for="password" class="form-label">Password</label>
              <input
                type="password"
                id="password"
                data-test="login-password"
                class="form-control form-control-lg"
                placeholder="Enter your password"
                [(ngModel)]="password"
                name="password"
                required
              />
            </div>
            <div>
              @if (errorMessage && errorMessage !== '') {
                <div class="alert alert-danger mb-3" role="alert">
                  {{ errorMessage }}
                </div>
              }
            </div>
          }
          <button
            class="w-100 mt-4 form-item mon-bg-primary mon-text-primary"
            data-test="login-button"
            mat-flat-button
            (click)="Login()"
          >
            <span>LOGIN</span>
          </button>
          @if (newLogin) {
            <div class="mt-3">
              <a
                data-test="forgot-password-link"
                class="d-block w-100 text-decoration-underline text-center text-dark"
                href="/authentication/forgot-password"
                >Forgot your password?</a
              >
            </div>
          }
        </form>
      } @else if (newLogin && step === 'mfa') {
        <div class="mt-3">
          <odin-mfa-auth-step [mfaConfig]="mfaConfig"></odin-mfa-auth-step>
          <button
            class="w-100 mt-4 form-item d-block border-0 bg-transparent text-dark"
            data-test="back-to-login-button"
            mat-flat-button
            (click)="GoBack()"
          >
            <span class="text-dark">Go Back</span>
          </button>
        </div>
      }
    </div>

    <odin-loading-spinner
      [active]="loggingIn"
      [overlay]="true"
    ></odin-loading-spinner>
  </div>
</div>
